import React from "react"
import ReactEcharts from "echarts-for-react"
import PropTypes from "prop-types"

const LeadToSale = ({ chartData }) => {
  // Value is already a percentage from backend (e.g., 67, not 0.67)
  const percentageValue = typeof chartData === 'number' && !isNaN(chartData)
    ? Math.round(chartData)
    : (typeof chartData === 'string' && !isNaN(Number(chartData)) ? Math.round(Number(chartData)) : 0)


  console.log("chartData received:", chartData, "type:", typeof chartData)
  console.log("percentageValue", percentageValue)

  const option = {
    series: [
      {
        name: "Sale To Lead Conversion",
        type: "gauge",
        detail: {
          formatter: "{value}%",
          textStyle: {
            fontSize: 20,
          },
        },

        axisLine: {
          lineStyle: {
            color: [
              [0.2, "#e8f0fe"],
              [0.8, "#a8c5f7"],
              [1, "#556ee6"],
            ],
            width: 20,
          },
        },
        title: {
          show: true,
          text: "Custom Title",
          textStyle: {
            color: "#556ee6",
            fontSize: 12,
          },
        },
        data: [
          {
            value: percentageValue,
            name: "Sale Ratio",
          },
        ],
      },
    ],
  }

  return (
    <React.Fragment>
      <ReactEcharts
        style={{ height: "300px", marginTop: -20 }}
        option={option}
      />
    </React.Fragment>
  )
}

export default LeadToSale

LeadToSale.propTypes = {
  chartData: PropTypes?.any,
}
